<div class="d-flex flex-column h-100">
  <app-nav-bar></app-nav-bar>

  <div class="container mt-5 flex-grow-1 flex-shrink-1">
    <router-outlet></router-outlet>
    <!--app-product-editor [product]="productExample"></app-product-editor-->
  </div>
  <app-toast-container></app-toast-container>

  <app-footer></app-footer>
</div>